import en, { type MessageKey } from './en';
import de from './de';
import el from './el';
import { getDefaultLanguage, isLanguageSupported } from '../utils/languages';

export type { MessageKey };

const TRANSLATIONS: Record<string, Record<MessageKey, string>> = {
  en,
  de,
  el,
};

export function getMessages(locale: string): Record<MessageKey, string> {
  const code = isLanguageSupported(locale) ? locale : getDefaultLanguage();
  return TRANSLATIONS[code] ?? en;
}
